import api from "@/config/apiConfig"

export default {
  async list() {
    const { data } = await api.get('/quick-messages')
    return data
  },
  async create(payload) {
    const { data } = await api.post('/quick-messages', payload)
    return data
  },
  async update(id, payload) {
    const { data } = await api.patch(`/quick-messages/${id}`, payload)
    return data
  },
  async delete(id) {
    const { data } = await api.delete(`/quick-messages/${id}`)
    return data
  },
  async getAiSuggestions(ticketId, prompt) {
    const { data } = await api.get(`/quick-messages/ai-suggestions/${ticketId}`, { params: { prompt } })
    return data
  }
}
